export enum Roles {
	scanmed = 'Admin',
	pampamed = 'Admin',
	medico = 'Medico',
	paciente = 'Paciente',
	unknown = 'Unknown',
}
